<template>
  <div>
    <div class="flex-1 w-full text-left px-4 py-2 mt-12">
      <div class="ml-auto mr-auto text-center">
        <h1>{{ getText('adjust_title') }}</h1>
      </div>
      <div class="text">{{ getText('adjust_text') }}</div>
      <div class="ml-auto mr-auto flex flex-col text-center">
        <div class="videocontainer">
        </div>
        <div class="clear-both mt-16"></div>
        <router-link :to="{ name: 'intro', params: { lang: $route.params.lang }}">
          <button
            class="bg-white text-black font-bold py-3 px-10 rounded-full w-full"
            style="width: 848px"
          >{{ getText('button_ok') }}</button>
        </router-link>
      </div>
    </div>
    <div id="updown">
      <div class="flex">
        <img src="images/updown.svg" style="width: 75px; margin-right: 10px" />
        {{ getText('adjust_button') }}
      </div>
    </div>
  </div>
</template>

<style scoped>
h1 {
  font-family: FoundryWilsonMedium;
  font-size: 66px;
  text-transform: uppercase;
}

.text {
  font-family: FoundryWilsonNormal;
  font-size: 28px;
  width: 950px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 30px;
  margin-bottom: 40px;
  text-align: center;
  letter-spacing: 2px;
}

.videocontainer {
  width: 848px;
  height: 480px;
}

#updown {
  font-family: FoundryWilsonNormal;
  font-size: 20px;
  line-height: 105%;
  letter-spacing: 1px;
  position: absolute;
  left: 20px;
  bottom: 20px;
  width: 250px;
}
</style>

<script>
export default {
  name: "Adjust",

  methods: {
    getText(key) {
      return this.$settings.interface[key][this.$route.params.lang];
    }
  },

  mounted() {
    if (global.wpfBridge) {
      global.wpfBridge.adjustEnter();
    }
  },

  beforeDestroy() {
    if (global.wpfBridge) {
      global.wpfBridge.adjustLeave();
    }
  }
};
</script>

